<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Shahriar Shahir's life turning point was Shana’s birth in 2000. His main characteristics are being patriotic and philomath and having a great passion for learning. His motto is love, courage, effort, and faith.</p><br/>
<p style="text-indent: 00em;">He has dedicated his life to work and striving for success, growth, and development. Although he faced obstacles during his path, he gained valuable achievements.</p><br/>
<p style="text-indent: 00em;">He got a scholarship from Emirates Flying School and obtained a Pilot's License. He had the incredible privilege of having many careers. However, his passion has always been business and he believes he grew up in it.</p><br/>
<p style="text-indent: 00em;">He implemented the dream of establishing a business with global standards in the franchise industry. At the same time, he created the Hoopoe brand, which is the fruit of many years of experience in the business world. In parallel, he published nine books about the standardization of the franchise industry which contain more than 1000 pages and are registered and certified by UAE.</p><br/>
<p style="text-indent: 00em;">He believes he is still at the beginning of this journey</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b55fe512